import React from "react";
import { AreaChart } from "react-chartkick";
import { toISODate } from "../helpers";

const dateToHours = date => date.getHours() + date.getMinutes() / 60;

const WorkEfficiencyChart = ({ poms }) => {
  const days = {};

  poms.forEach(pom => {
    const date = toISODate(pom.stop);
    days[date] ||
      (days[date] = {
        poms: 0,
        startedAt: 24,
        stoppedAt: 0
      });

    const startedHours = dateToHours(pom.start);
    const stoppedHours = dateToHours(pom.stop);

    days[date] = {
      poms: days[date].poms + 1,
      startedAt: Math.min(startedHours, days[date].startedAt),
      stoppedAt: Math.max(stoppedHours, days[date].stoppedAt)
    };
  });

  // calculate efficiency
  const points = {};
  Object.keys(days).forEach(day => {
    const meta = days[day];
    const totalHours = meta.stoppedAt - meta.startedAt;
    const perfectHours = meta.poms * 0.5;

    // 100% efficient: 8 poms in 4 hours
    // 50% efficient: 8 poms in 6 hours
    // 100% efficient: 1 pom in 30 minutes
    const efficiency = perfectHours / totalHours;

    if (meta.poms >= 8) points[day] = efficiency * 100;
  });

  return (
    <AreaChart
      data={points}
      xtitle="Date"
      ytitle="Efficiency"
      curve={true}
      download={"workefficiency"}
      title={"Work Efficiency of 8-pom days"}
      colors={["#2ecc71"]}
      max={100}
      min={0}
    />
  );
};

export default WorkEfficiencyChart;



// WEBPACK FOOTER //
// ./src/charts/WorkEfficiencyChart.js